package io.writeopia.ui.model

enum class EmptyErase {
    DELETE,
    CHANGE_TYPE,
    DISABLED
}